import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import config from '../config/config';
import verified from '../assets/images/verified.svg';
import loaderIcon from '../assets/images/loader.gif';
import CustomSliderWithoutLogin from './CustomSliderWithoutLogin';

const FeaturedPostAbout = () => {
  const [posts, setPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMorePosts, setHasMorePosts] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      if (loading || !hasMorePosts) return; // Prevent multiple requests

      setLoading(true);
      try {
        const response = await axios.get(`${config.baseURL}/get-posts-without-login`, {
          params: { page: currentPage }
        });
        if (response.data.success) {
          const newPosts = response.data.posts || [];

          // Set last page from API response
          setLastPage(response.data.last_page);

          // Add new posts and filter for unique ones by ID
          setPosts(prevPosts => {
            const allPosts = [...prevPosts, ...newPosts];
            return Array.from(new Set(allPosts.map(post => post.id)))
              .map(id => allPosts.find(post => post.id === id));
          });

          // Update hasMorePosts if there are more pages to fetch
          setHasMorePosts(currentPage < response.data.last_page);
        }
      } catch (error) {
        console.error('Error fetching posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [currentPage, hasMorePosts]);

  const loadMorePosts = () => {
    if (currentPage < lastPage && !loading) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

 const getContentWithLinks = (content, mentions) => {
    if (!mentions.length) return content;

    let updatedContent = content;

    mentions.forEach(mention => {
      const mentionText = `@${mention.user.user_name}`;
      const mentionLink = `/${mention.user.user_name}`;
      const regex = new RegExp(`(${mentionText})(?![^<]*>)`, 'g');
      updatedContent = updatedContent.replace(regex, `<a href="${mentionLink}">${mentionText}</a>`);
    });

    return updatedContent;
  };


  return (
    <section className="blog_post_wrap">
      <div className="container custom_container">
        <div className="row">
          <div className="col-md-12">
            <div className="blog_posts">
              <h2>Latest featured posts</h2>
              {posts.slice(0, 10).map(post => (
                <div className="blog_post_box" key={post.id}>
                  <div className="blog_post_content">
                    <div className="content_blog_box">
                      <div className="client-info d-flex">
                        <div className="client_info_left">
                          <div className="client-img">
                            <div className="lazy-container">
                              <Link to="/login">
                                <img
                                  src={post.user.user_details.profile || "https://via.placeholder.com/150"}
                                  alt="Person Image"
                                />
                              </Link>
                            </div>
                          </div>
                          <div className="content">
                            <h6 className="name">
                              <Link to="/login">
                                {post.user.name} <img src={verified} alt="" />
                              </Link>
                            </h6>
                            <span className="designation">
                              <Link to="/login">@{post.user.user_name}</Link>
                            </span>
                          </div>
                        </div>
                        <div className="client_info_right">
                          <span className="post_time">
                            <Link to="/login">{post.created_at_human}</Link>
                          </span>
                        </div>
                      </div>
                      <p dangerouslySetInnerHTML={{ __html: getContentWithLinks(post.content, post.mentions) }} />
                    </div>
                  </div>
                  {/* Custom Slider Without Login */}
                  {(post.is_auth_user_post || post.type !== 'paid' || post.purchase_status === 'purchased') && 
                    post.media.length > 0 && (
                      <CustomSliderWithoutLogin
                        media={post.media.map((mediaItem) => ({
                          url: mediaItem.url,
                          isVideo: /\.(mp4|webm|ogg|avi|mov|wmv|flv|mkv)$/i.test(mediaItem.url),
                        }))}
                      />
                  )}
                </div>
              ))}

              <div className="row">
                <div className="col-md-12">
                  <div className="load_more text-center">
                    {loading ? (
                      <img src={loaderIcon} className="loading_icon" alt="Loading..." />
                    ) : hasMorePosts ? (
                      <Link className="btn btn-lg btn-primary" onClick={loadMorePosts}>
                        Show More
                      </Link>
                    ) : (
                      <p className="no_list">No more posts to show</p>
                    )}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPostAbout;
